import styled from 'styled-components'
import { Text } from 'components/Text'
import { mobileFirstMedia as media } from 'utils/media'

export const OrderBox = styled.div`
  padding: 40px 0 15px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  background-color: ${props => props.theme.colors.white};
  display: flex;
  flex-direction: column;
  align-items: ${props => (props.centered ? 'center' : 'flex-start')};
  max-height: calc(100vh - 40px);
  overflow-x: hidden;
  overflow-y: scroll;

  ${media.screen`
    & > div {
      display: flex;
      flex-direction: column;
    }
  `}
`

export const Description = styled(Text)`
  width: 240px;
  margin: 5px auto 30px !important;
`

export const OrderListContainer = styled.ul`
  flex-shrink: 1;
  width: 100%;
  overflow: auto;
`

export const Separator = styled.div`
  margin: 20px 15px 0;
  height: 1px;
  width: calc(100% - 30px);
  background-color: ${p => p.theme.colors.gray5};
`
